module.exports = __webpack_public_path__ + "img/book.e92e2f82.png";